import { Slot } from '@radix-ui/react-slot';
import { memo, type ReactNode, type UIEvent } from 'react';
import { classNames } from '~/utils/classNames';

interface DropdownButtonProps {
  className?: string;
  onClick?: (event: UIEvent) => void;
  children: ReactNode;
  disabled?: boolean;
  asChild?: true;
}

export const DropdownButton = memo<DropdownButtonProps>(({ className, onClick, children, disabled, asChild }) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      className={classNames(
        'flex items-center gap-2 px-2.75 py-1.5 rounded bg-transparent enabled:hover:bg-bolt-ds-surfaceHighlight text-xs min-h-[30px] disabled:cursor-not-allowed disabled:opacity-50',
        {
          'hover:bg-bolt-elements-item-backgroundActive': asChild,
        },
        className,
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Comp>
  );
});
